import { Snackbar } from "@material-ui/core"
import { ComponentType, createContext, FC, useState } from "react"

const ErrorContext = createContext((errorText: string) => {})

export const ErrorProvider: FC = ({ children }) => {
  const [errorText, setErrorText] = useState("")
  const [open, setIsOpen] = useState(false)

  const showError = (errorText: string) => {
    setErrorText(errorText)
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <ErrorContext.Provider value={showError}>
      {children}
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        onClose={handleClose}
        message={errorText}
        autoHideDuration={5000}
        key={"error-snackbar"}
      />
    </ErrorContext.Provider>
  )
}

// Wrapper function for components that will present LobbyDetails sheet
export function withErrorContext<T>(Component: ComponentType<T>) {
  return (props: T) => (
    <ErrorContext.Consumer>{value => <Component {...props} showError={value} />}</ErrorContext.Consumer>
  )
}
